
import { withTranslation } from "react-i18next";
import InventoryDetail from "./InventoryDetail";

export default withTranslation()(InventoryDetail);
